<template>
    <form-input :error="error">
        <div class="col-xs-6 float-left" v-if="label">
            <app-label :for="id">
                {{ label }} <template v-if="isRequired"><span class="asterisk">*</span></template>
            </app-label>
        </div>
        <textarea
            :id="id"
            @input="onInput"
            @focus="onFocus"
            :name="name"
            :rows="rows"
            :cols="cols"
            :required="isRequired"
            :disabled="isDisabled"
            :autocomplete="autocomplete"
            :placeholder="placeholder"
            :maxlength="maxLength">{{ value }}</textarea>
        <help-block :text="error"/>
    </form-input>
</template>

<script>
    export default {
        props: {
            id: String,
            placeholder: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: ''
            },
            isRequired: {
                type: Boolean,
                default: false
            },
            isDisabled: {
                type: Boolean,
                default: false
            },
            name: {
                type: String,
                default: ''
            },
            autocomplete: {
                type: String,
                default: 'off'
            },
            value: String,
            error: {
                type: String,
                default: ''
            },
            rows: String,
            cols: String,
            liveCount: Function,
            maxLength: Number,
            index: Number
        },
        mounted(){
            if(this.liveCount){
                this.liveCount(this.value, this.index);
            }
        },
        methods: {
            onInput(e) {
                if(this.liveCount){
                    this.liveCount(e.target.value, this.index);
                }
                this.$emit('input', e.target.value);
            },
            onFocus(e) {
                this.$emit('focus', e.target.value);
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import "resources/sass/_variables";

    textarea {
        display: block;
        width: 100%;
        padding: 0.375rem 0.75rem;
        font-size: $primary-font-size;
        font-weight: 400;
        line-height: 1.6;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

        &:focus {
            border: none;
            outline: none;
            box-shadow: 0 0 5px 0 $primary-color;
        }

        &:disabled {
            cursor: not-allowed;
            background-color: $disabled_input_background_color;
        }
    }
</style>
